var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGsLogoGoktas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.7,
    y: 11.1,
    className: "st0",
    width: 13.1,
    height: 109.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.5,30.6c0-11.6,9.3-21.1,20.9-21.1S88.2,19,88.2,30.6s-9.3,21.1-20.9,21.1S46.5,42.2,46.5,30.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 132.7,
    cy: 101.1,
    rx: 20.9,
    ry: 21.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.8,181.2l1.7,6.1h4.1v-25.7H23.2v5.5h15.5c0.1,2.2-0.2,4.3-0.9,6.3c-0.7,1.9-1.7,3.6-3.1,5.1 c-1.3,1.4-3,2.5-4.9,3.3c-2,0.8-4.2,1.2-6.7,1.2c-2.7,0-5.1-0.5-7.2-1.6c-2-1.1-3.8-2.5-5.2-4.3s-2.5-3.9-3.2-6.2 c-0.7-2.4-1.1-4.8-1.1-7.4c0-2.6,0.3-5.1,1-7.6c0.6-2.5,1.6-4.7,2.9-6.6c1.4-2,3.1-3.5,5.2-4.7s4.7-1.8,7.6-1.8 c1.8,0,3.5,0.2,5.1,0.7c1.6,0.4,3.1,1,4.4,1.9s2.3,2,3.2,3.3s1.5,2.9,1.8,4.8h6.5c-0.5-2.9-1.3-5.3-2.6-7.3 c-1.2-2-2.8-3.7-4.6-5.1c-1.8-1.3-3.9-2.3-6.3-2.9c-2.3-0.6-4.8-1-7.4-1c-3.9,0-7.2,0.7-10.2,2.2c-2.9,1.4-5.3,3.3-7.2,5.7 s-3.4,5.2-4.4,8.5c-1,3.2-1.4,6.6-1.4,10.1c0,3.2,0.5,6.3,1.6,9.2c1,3,2.6,5.6,4.6,7.9c2,2.3,4.4,4.1,7.3,5.5c2.9,1.3,6.1,2,9.7,2 c2.9,0,5.7-0.5,8.5-1.6C34.5,185.6,36.9,183.8,38.8,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.3,170.9c0,7.4,4.2,12.9,10.1,12.9c5.8,0,10.2-5.5,10.2-13.1c0-5.7-2.8-12.9-10-12.9 C60.4,157.9,57.3,164.6,57.3,170.9z M83.8,170.6c0,12.4-8.7,17.9-16.7,17.9c-9,0-16.1-6.7-16.1-17.3c0-11.2,7.4-17.8,16.6-17.8 C77.3,153.3,83.8,160.4,83.8,170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.6,169.5L97.6,169.5c0.9-1.2,2-2.6,3-3.8l9.9-11.6h7.3l-12.9,13.8l14.8,19.8h-7.5l-11.5-16.1l-3.1,3.5 v12.6h-6v-49.3h6C97.6,138.4,97.6,169.5,97.6,169.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,146v8.1h8.7v4.7h-8.7v18.1c0,4.2,1.2,6.5,4.6,6.5c1.7,0,2.6-0.1,3.5-0.4l0.3,4.7 c-1.2,0.4-3,0.8-5.4,0.8c-2.8,0-5.1-1-6.6-2.6c-1.7-1.9-2.4-4.9-2.4-8.8v-18.3h-5.2V154h5.2v-6.3L131.4,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.6,170.5c-6.7-0.1-14.2,1-14.2,7.6c0,4,2.6,5.8,5.7,5.8c4.4,0,7.3-2.8,8.2-5.6c0.2-0.7,0.3-1.4,0.3-1.9 V170.5z M170.5,179.6c0,2.9,0.1,5.8,0.5,8.1h-5.5l-0.5-4.2h-0.2c-1.9,2.6-5.5,5-10.3,5c-6.8,0-10.3-4.8-10.3-9.7 c0-8.1,7.2-12.6,20.2-12.5v-0.7c0-2.7-0.8-7.8-7.6-7.7c-3.2,0-6.4,0.9-8.8,2.5l-1.4-4.1c2.8-1.7,6.9-2.9,11.1-2.9 c10.3,0,12.8,7,12.8,13.7V179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.6,181.5c1.9,1.1,5.1,2.4,8.1,2.4c4.4,0,6.4-2.2,6.4-5c0-2.9-1.7-4.4-6.2-6.1c-6.1-2.2-8.9-5.5-8.9-9.5 c0-5.4,4.4-9.9,11.6-9.9c3.4,0,6.4,0.9,8.2,2.1l-1.5,4.4c-1.3-0.8-3.7-2-6.9-2c-3.6,0-5.5,2.1-5.5,4.6c0,2.8,1.9,4,6.3,5.8 c5.8,2.2,8.8,5.1,8.8,10.1c0,6-4.6,10.1-12.5,10.1c-3.7,0-7.1-1-9.4-2.4L179.6,181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.5,153c0-2.5,1.7-4.4,4.2-4.4c2.4,0,4.1,1.8,4.1,4.4c0,2.5-1.7,4.4-4.2,4.4 C59.2,157.4,57.5,155.5,57.5,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,153c0-2.5,1.7-4.4,4.2-4.4c2.4,0,4.1,1.8,4.1,4.4c0,2.5-1.7,4.4-4.2,4.4 C71.1,157.4,69.4,155.5,69.4,153z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.1,
    y: 185.5,
    className: "st0",
    width: 5.5,
    height: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsLogoGoktas);
export default __webpack_public_path__ + "static/media/gs_logo-goktas.752ff8cb56d75f098a5f81cdd26bd8d6.svg";
export { ForwardRef as ReactComponent };